import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import s from './Number.module.scss'
export type NumberProps = { className?: string; children?: ReactNode }
const Number: FC<NumberProps> = ({ children, className }) => {
  return <span className={clsx(s.root, className)}>{children}</span>
}

export default Number
